@import 'styles/variables';
@import 'styles/mixins';

$drop-thickness: 2px;

.DropPoint {
  width: 100%;
  height: $drop-thickness;
  position: absolute;
  border-radius: 100px;
  z-index: 1; // to appear above image nodeView
  contain: layout size style;

  &.left {
    width: $drop-thickness;
    height: var(--size);
    transform: translateX(-5px);
  }
  &.right {
    width: $drop-thickness;
    height: var(--size);

    transform: translate(var(--offset), calc(-1 * var(--size)));
  }
  &.valid {
    background: var(--focus-50);
  }
  &.invalid {
    background: var(--negative-50);
  }

  &:is(.top, .bottom)[data-depth]::before {
    content: '';
    display: block;
    height: 100%;
    background: var(--focus-50);
    opacity: 0.25;
  }

  @for $i from 1 through 10 {
    // drop point for nested lists (indent markers)
    $gap: 4px;
    &:is(.top, .bottom)[data-depth='#{$i}'] {
      $indent-marker-width: 26px * $i;
      width: calc(var(--size) - #{$indent-marker-width + $gap});
      transform: translateX($indent-marker-width + $gap);
      &::before {
        width: $indent-marker-width;
        transform: translateX(-($indent-marker-width + $gap));
      }
    }
  }

  [data-type='column'] > &,
  [data-type='column']
    > *:is([data-type='ordered_list'], [data-type='unordered_list'], [data-type='check_list'], [data-type='vote_list'])
    &:not([data-depth]) {
    &.top,
    &.bottom {
      width: var(--size);
    }
  }
}

.dragging {
  cursor: grabbing;
}

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
:global(#dragClone) {
  pointer-events: none;
  opacity: 0.5;
  position: absolute;
}

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
:global(.ProseMirror.ProseMirror) {
  // HACK: boost specificity

  .dragSource {
    background: var(--focus-10);
    border-radius: 8px;
  }
}

[data-node-type='column_group'] {
  .DropPoint {
    justify-self: center;

    &.left {
      grid-area: before;
    }
    &.right {
      grid-area: after;
    }
    &.left,
    &.right {
      width: $drop-thickness;
      height: 100%;
      position: static;
    }
  }
  [data-type='column'] + .DropPoint {
    &.right {
      grid-area: a-b;
      transform: none;
    }
    &.bottom {
      position: static; // the default position: absolute makes the drop point appear above the nodeView
      grid-column: before / after; // make it span since we're removing position: absolute
      margin-bottom: -$drop-thickness; // compensate for the 2px height (since we're removing position: absolute)
    }
  }
  [data-columns='2'] {
    [data-type='column'] ~ [data-type='column'] ~ .DropPoint.right {
      grid-area: after;
    }
  }
  [data-columns='3'] {
    [data-type='column'] ~ [data-type='column'] ~ .DropPoint.right {
      grid-area: b-c;
    }
    [data-type='column'] ~ [data-type='column'] ~ [data-type='column'] ~ .DropPoint.right {
      grid-area: after;
    }
  }
}
